window.BORDERPLAN_DATA = {

  "PAK-BOR-ZON-3M": {
    pakket: "zon & halfschaduw",
    handle: "borderpakket-zon-halfschaduw-met-varianten",
    size: "3m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-zon-halfschaduw-3m.jpg",
    image_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-zon-halfschaduw-3m-organisch.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-zon-halfschaduw-3m.pdf",
    pdf_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-zon-halfschaduw-3m-organisch.pdf",
    plants: [
      { name: "Sedum 'Herbstfreude'", handle: "sedum-h-herbstfreude", qty: 3 },
      { name: "Nepeta 'Cats Pajamas'", handle: "nepeta-cats-pajamas", qty: 5 },
      { name: "Pennisetum orientale 'Flamingo'", handle: "pennisetum-orientale-flamingo", qty: 2 },
      { name: "Verbascum chaixii 'Album'", handle: "verbascum-chaixii-album", qty: 3 },
      { name: "Stachys byzantina 'Big Ears'", handle: "stachys-byzantina-big-ears", qty: 3 },
      { name: "Salvia nemorosa 'Amethyst'", handle: "salvia-nemorosa-amethyst", qty: 3 },
      { name: "Eupatorium purpureum", handle: "eupatorium-purpureum", qty: 1 },
      { name: "Helleborus 'Single Red'", handle: "helleborus-single-red", qty: 3 },
      { name: "Aster ageratoides 'Asran'", handle: "aster-ageratoides-asran", qty: 3 },
      { name: "Anemone hybrida 'K\u00f6nigin Charlotte'", handle: "anemone-hybrida-konigin-charlotte", qty: 3 },
    ],
  },
  "PAK-BOR-ZON-6M": {
    pakket: "zon & halfschaduw",
    handle: "borderpakket-zon-halfschaduw-met-varianten",
    size: "6m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-zon-halfschaduw-6m.jpg",
    image_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-zon-halfschaduw-6m-organisch.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-zon-halfschaduw-6m.pdf",
    pdf_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-zon-halfschaduw-6m-organisch.pdf",
    plants: [
      { name: "Sedum 'Herbstfreude'", handle: "sedum-h-herbstfreude", qty: 5 },
      { name: "Nepeta 'Cats Pajamas'", handle: "nepeta-cats-pajamas", qty: 7 },
      { name: "Pennisetum orientale 'Flamingo'", handle: "pennisetum-orientale-flamingo", qty: 3 },
      { name: "Stachys byzantina 'Big Ears'", handle: "stachys-byzantina-big-ears", qty: 5 },
      { name: "Verbascum chaixii 'Album'", handle: "verbascum-chaixii-album", qty: 5 },
      { name: "Salvia nemorosa 'Amethyst'", handle: "salvia-nemorosa-amethyst", qty: 9 },
      { name: "Eupatorium purpureum", handle: "eupatorium-purpureum", qty: 2 },
      { name: "Helleborus 'Single Red'", handle: "helleborus-single-red", qty: 6 },
      { name: "Anemone hybrida 'K\u00f6nigin Charlotte'", handle: "anemone-hybrida-konigin-charlotte", qty: 6 },
      { name: "Aster ageratoides 'Asran'", handle: "aster-ageratoides-asran", qty: 7 },
    ],
  },
  "PAK-BOR-ZON-9M": {
    pakket: "zon & halfschaduw",
    handle: "borderpakket-zon-halfschaduw-met-varianten",
    size: "9m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-zon-halfschaduw-9m.jpg",
    image_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-zon-halfschaduw-9m-organisch.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-zon-halfschaduw-9m.pdf",
    pdf_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-zon-halfschaduw-9m-organisch.pdf",
    plants: [
      { name: "Sedum 'Herbstfreude'", handle: "sedum-h-herbstfreude", qty: 7 },
      { name: "Nepeta 'Cats Pajamas'", handle: "nepeta-cats-pajamas", qty: 12 },
      { name: "Pennisetum orientale 'Flamingo'", handle: "pennisetum-orientale-flamingo", qty: 5 },
      { name: "Stachys byzantina 'Big Ears'", handle: "stachys-byzantina-big-ears", qty: 9 },
      { name: "Verbascum chaixii 'Album'", handle: "verbascum-chaixii-album", qty: 9 },
      { name: "Salvia nemorosa 'Amethyst'", handle: "salvia-nemorosa-amethyst", qty: 15 },
      { name: "Eupatorium purpureum", handle: "eupatorium-purpureum", qty: 3 },
      { name: "Helleborus 'Single Red'", handle: "helleborus-single-red", qty: 9 },
      { name: "Anemone hybrida 'K\u00f6nigin Charlotte'", handle: "anemone-hybrida-konigin-charlotte", qty: 12 },
      { name: "Aster ageratoides 'Asran'", handle: "aster-ageratoides-asran", qty: 9 },
    ],
  },
  "PAK-BOR-VOGE-3M": {
    pakket: "vogels & bestuivers",
    handle: "borderpakket-vogels-bestuivers-met-varianten",
    size: "3m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-vogels-bestuivers-3m.jpg",
    image_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-vogels-bestuivers-3m-organisch.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-vogels-bestuivers-3m.pdf",
    pdf_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-vogels-bestuivers-3m-organisch.pdf",
    plants: [
      { name: "Agastache foeniculum 'Black Adder'", handle: "agastache-foeniculum-black-adder", qty: 3 },
      { name: "Calamintha nepeta", handle: "calamintha-nepeta", qty: 2 },
      { name: "Geranium 'Azure Rush'", handle: "geranium-azure-rush", qty: 3 },
      { name: "Verbena bonariensis", handle: "verbena-bonariensis", qty: 2 },
      { name: "Astrantia 'Buckland'", handle: "astrantia-buckland", qty: 5 },
      { name: "Achillea millefolium 'Paprika'", handle: "achillea-millefolium-paprika", qty: 3 },
      { name: "Echinops ritro", handle: "echinops-ritro", qty: 3 },
      { name: "Eupatorium maculatum 'Atropurpureum'", handle: "eupatorium-maculatum-atropurpureum", qty: 1 },
      { name: "Anemone hupehensis 'September Charm'", handle: "anemone-hupehensis-september-charm", qty: 2 },
      { name: "Echinacea purpurea", handle: "echinacea-purpurea", qty: 3 },
      { name: "Knautia macedonica 'Melton Pastels'", handle: "knautia-macedonica-melton-pastels", qty: 3 },
    ],
  },
  "PAK-BOR-VOGE-6M": {
    pakket: "vogels & bestuivers",
    handle: "borderpakket-vogels-bestuivers-met-varianten",
    size: "6m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-vogels-bestuivers-6m.jpg",
    image_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-vogels-bestuivers-6m-organisch.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-vogels-bestuivers-6m.pdf",
    pdf_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-vogels-bestuivers-6m-organisch.pdf",
    plants: [
      { name: "Agastache foeniculum 'Black Adder'", handle: "agastache-foeniculum-black-adder", qty: 5 },
      { name: "Calamintha nepeta", handle: "calamintha-nepeta", qty: 4 },
      { name: "Geranium 'Azure Rush'", handle: "geranium-azure-rush", qty: 7 },
      { name: "Verbena bonariensis", handle: "verbena-bonariensis", qty: 4 },
      { name: "Astrantia 'Buckland'", handle: "astrantia-buckland", qty: 7 },
      { name: "Anemone hupehensis 'September Charm'", handle: "anemone-hupehensis-september-charm", qty: 5 },
      { name: "Echinacea purpurea", handle: "echinacea-purpurea", qty: 9 },
      { name: "Echinops ritro", handle: "echinops-ritro", qty: 5 },
      { name: "Eupatorium maculatum 'Atropurpureum'", handle: "eupatorium-maculatum-atropurpureum", qty: 3 },
      { name: "Achillea millefolium 'Paprika'", handle: "achillea-millefolium-paprika", qty: 6 },
      { name: "Knautia macedonica 'Melton Pastels'", handle: "knautia-macedonica-melton-pastels", qty: 6 },
    ],
  },
  "PAK-BOR-VOGE-9M": {
    pakket: "vogels & bestuivers",
    handle: "borderpakket-vogels-bestuivers-met-varianten",
    size: "9m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-vogels-bestuivers-9m.jpg",
    image_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-vogels-bestuivers-9m-organisch.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-vogels-bestuivers-9m.pdf",
    pdf_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-vogels-bestuivers-9m-organisch.pdf",
    plants: [
      { name: "Agastache foeniculum 'Black Adder'", handle: "agastache-foeniculum-black-adder", qty: 9 },
      { name: "Calamintha nepeta", handle: "calamintha-nepeta", qty: 7 },
      { name: "Geranium 'Azure Rush'", handle: "geranium-azure-rush", qty: 9 },
      { name: "Verbena bonariensis", handle: "verbena-bonariensis", qty: 5 },
      { name: "Astrantia 'Buckland'", handle: "astrantia-buckland", qty: 12 },
      { name: "Anemone hupehensis 'September Charm'", handle: "anemone-hupehensis-september-charm", qty: 7 },
      { name: "Knautia macedonica 'Melton Pastels'", handle: "knautia-macedonica-melton-pastels", qty: 9 },
      { name: "Achillea millefolium 'Paprika'", handle: "achillea-millefolium-paprika", qty: 9 },
      { name: "Eupatorium maculatum 'Atropurpureum'", handle: "eupatorium-maculatum-atropurpureum", qty: 5 },
      { name: "Echinops ritro", handle: "echinops-ritro", qty: 9 },
      { name: "Echinacea purpurea", handle: "echinacea-purpurea", qty: 15 },
    ],
  },
  "PAK-BOR-SCHA-3M": {
    pakket: "schaduw",
    handle: "borderpakket-schaduw-met-varianten",
    size: "3m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-schaduw-3m.jpg",
    image_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-schaduw-3m-organisch.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-schaduw-3m.pdf",
    pdf_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-schaduw-3m-organisch.pdf",
    plants: [
      { name: "Asplenium scolopendrium", handle: "asplenium-scolopendrium", qty: 3 },
      { name: "Daslook", handle: "allium-ursinum", qty: 6 },
      { name: "Epimedium pubigerum 'Orangek\u00f6nigin'", handle: "epimedium-pubigerum-orangekonigin", qty: 6 },
      { name: "Tiarella wherryi", handle: "tiarella-wherryi", qty: 3 },
      { name: "Hosta 'Krossa Regal'", handle: "hosta-krossa-regal", qty: 3 },
      { name: "Liriope muscari \u2018Monroe White\u2019", handle: "liriope-muscari-monroe-white", qty: 5 },
      { name: "Actaea simplex 'Brunette'", handle: "actaea-simplex-brunette-1", qty: 3 },
    ],
  },
  "PAK-BOR-SCHA-6M": {
    pakket: "schaduw",
    handle: "borderpakket-schaduw-met-varianten",
    size: "6m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-schaduw-6m.jpg",
    image_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-schaduw-6m-organisch.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-schaduw-6m.pdf",
    pdf_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-schaduw-6m-organisch.pdf",
    plants: [
      { name: "Asplenium scolopendrium", handle: "asplenium-scolopendrium", qty: 5 },
      { name: "Daslook", handle: "allium-ursinum", qty: 12 },
      { name: "Epimedium pubigerum 'Orangek\u00f6nigin'", handle: "epimedium-pubigerum-orangekonigin", qty: 9 },
      { name: "Liriope muscari \u2018Monroe White\u2019", handle: "liriope-muscari-monroe-white", qty: 10 },
      { name: "Hosta 'Krossa Regal'", handle: "hosta-krossa-regal", qty: 5 },
      { name: "Tiarella wherryi", handle: "tiarella-wherryi", qty: 6 },
      { name: "Actaea simplex 'Brunette'", handle: "actaea-simplex-brunette-1", qty: 6 },
    ],
  },
  "PAK-BOR-SCHA-9M": {
    pakket: "schaduw",
    handle: "borderpakket-schaduw-met-varianten",
    size: "9m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-schaduw-9m.jpg",
    image_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-schaduw-9m-organisch.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-schaduw-9m.pdf",
    pdf_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-schaduw-9m-organisch.pdf",
    plants: [
      { name: "Asplenium scolopendrium", handle: "asplenium-scolopendrium", qty: 9 },
      { name: "Daslook", handle: "allium-ursinum", qty: 18 },
      { name: "Epimedium pubigerum 'Orangek\u00f6nigin'", handle: "epimedium-pubigerum-orangekonigin", qty: 12 },
      { name: "Tiarella wherryi", handle: "tiarella-wherryi", qty: 12 },
      { name: "Hosta 'Krossa Regal'", handle: "hosta-krossa-regal", qty: 7 },
      { name: "Liriope muscari \u2018Monroe White\u2019", handle: "liriope-muscari-monroe-white", qty: 18 },
      { name: "Actaea simplex 'Brunette'", handle: "actaea-simplex-brunette-1", qty: 12 },
    ],
  },
  "PAK-BOR-INHE-3M": {
    pakket: "inheems",
    handle: "borderpakket-inheems-met-varianten",
    size: "3m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-inheems-3m.jpg",
    image_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-inheems-3m-organisch.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-inheems-3m.pdf",
    pdf_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-inheems-3m-organisch.pdf",
    plants: [
      { name: "Geum rivale", handle: "geum-rivale", qty: 5 },
      { name: "Stachys officinalis", handle: "stachys-officinalis", qty: 5 },
      { name: "Dipsacus fullonum", handle: "dipsacus-fullonum", qty: 3 },
      { name: "Knautia arvensis", handle: "knautia-arvensis", qty: 5 },
      { name: "Trifolium rubens", handle: "trifolium-rubens", qty: 3 },
      { name: "Achillea millefolium", handle: "achillea-millefolium", qty: 5 },
      { name: "Sanguisorba officinalis", handle: "sanguisorba-officinalis", qty: 3 },
    ],
  },
  "PAK-BOR-INHE-6M": {
    pakket: "inheems",
    handle: "borderpakket-inheems-met-varianten",
    size: "6m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-inheems-6m.jpg",
    image_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-inheems-6m-organisch.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-inheems-6m.pdf",
    pdf_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-inheems-6m-organisch.pdf",
    plants: [
      { name: "Stachys officinalis", handle: "stachys-officinalis", qty: 9 },
      { name: "Geum rivale", handle: "geum-rivale", qty: 7 },
      { name: "Dipsacus fullonum", handle: "dipsacus-fullonum", qty: 5 },
      { name: "Knautia arvensis", handle: "knautia-arvensis", qty: 7 },
      { name: "Achillea millefolium", handle: "achillea-millefolium", qty: 7 },
      { name: "Sanguisorba officinalis", handle: "sanguisorba-officinalis", qty: 5 },
      { name: "Trifolium rubens", handle: "trifolium-rubens", qty: 5 },
    ],
  },
  "PAK-BOR-INHE-9M": {
    pakket: "inheems",
    handle: "borderpakket-inheems-met-varianten",
    size: "9m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-inheems-9m.jpg",
    image_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-inheems-9m-organisch.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-inheems-9m.pdf",
    pdf_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-inheems-9m-organisch.pdf",
    plants: [
      { name: "Geum rivale", handle: "geum-rivale", qty: 12 },
      { name: "Trifolium rubens", handle: "trifolium-rubens", qty: 12 },
      { name: "Achillea millefolium", handle: "achillea-millefolium", qty: 12 },
      { name: "Dipsacus fullonum", handle: "dipsacus-fullonum", qty: 7 },
      { name: "Knautia arvensis", handle: "knautia-arvensis", qty: 12 },
      { name: "Sanguisorba officinalis", handle: "sanguisorba-officinalis", qty: 15 },
      { name: "Stachys officinalis", handle: "stachys-officinalis", qty: 9 },
    ],
  },
  "PAK-BOR-COTT-3M": {
    pakket: "cottage core",
    handle: "borderpakket-cottage-core-met-varianten",
    size: "3m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-cottage-core-3m.jpg",
    image_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-cottage-core-3m-organisch.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-cottage-core-3m.pdf",
    pdf_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-cottage-core-3m-organisch.pdf",
    plants: [
      { name: "Nepeta 'Six Hills Giant'", handle: "nepeta-six-hills-giant", qty: 3 },
      { name: "Geranium sanguineum var. striatum", handle: "geranium-sanguineum-var-striatum", qty: 5 },
      { name: "Digitalis 'Mertonensis'", handle: "digitalis-mertonensis", qty: 3 },
      { name: "Agastache foeniculum 'Black Adder'", handle: "agastache-foeniculum-black-adder", qty: 3 },
      { name: "Sanguisorba officinalis 'Tanna'", handle: "sanguisorba-officinalis-tanna", qty: 2 },
      { name: "Aster ericoides", handle: "aster-ericoides", qty: 2 },
      { name: "Achillea millefolium 'Walter Funcke'", handle: "achillea-millefolium-walter-funcke", qty: 5 },
      { name: "Astrantia major 'Roma'", handle: "astrantia-major-roma", qty: 3 },
      { name: "Briza media", handle: "briza-media", qty: 3 },
      { name: "Erigeron karvinskianus", handle: "erigeron-karvinskianus-1", qty: 2 },
      { name: "Echinacea pallida", handle: "echinacea-pallida-1", qty: 3 },
    ],
  },
  "PAK-BOR-COTT-6M": {
    pakket: "cottage core",
    handle: "borderpakket-cottage-core-met-varianten",
    size: "6m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-cottage-core-6m.jpg",
    image_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-cottage-core-6m-organisch.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-cottage-core-6m.pdf",
    pdf_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-cottage-core-6m-organisch.pdf",
    plants: [
      { name: "Nepeta 'Six Hills Giant'", handle: "nepeta-six-hills-giant", qty: 5 },
      { name: "Geranium sanguineum var. striatum", handle: "geranium-sanguineum-var-striatum", qty: 9 },
      { name: "Digitalis 'Mertonensis'", handle: "digitalis-mertonensis", qty: 5 },
      { name: "Agastache foeniculum 'Black Adder'", handle: "agastache-foeniculum-black-adder", qty: 6 },
      { name: "Sanguisorba officinalis 'Tanna'", handle: "sanguisorba-officinalis-tanna", qty: 6 },
      { name: "Briza media", handle: "briza-media", qty: 5 },
      { name: "Erigeron karvinskianus", handle: "erigeron-karvinskianus-1", qty: 4 },
      { name: "Achillea millefolium 'Walter Funcke'", handle: "achillea-millefolium-walter-funcke", qty: 9 },
      { name: "Aster ericoides", handle: "aster-ericoides", qty: 3 },
      { name: "Astrantia major 'Roma'", handle: "astrantia-major-roma", qty: 6 },
      { name: "Echinacea pallida", handle: "echinacea-pallida-1", qty: 9 },
    ],
  },
  "PAK-BOR-COTT-9M": {
    pakket: "cottage core",
    handle: "borderpakket-cottage-core-met-varianten",
    size: "9m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-cottage-core-9m.jpg",
    image_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-cottage-core-9m-organisch.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-cottage-core-9m.pdf",
    pdf_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-cottage-core-9m-organisch.pdf",
    plants: [
      { name: "Nepeta 'Six Hills Giant'", handle: "nepeta-six-hills-giant", qty: 7 },
      { name: "Geranium sanguineum var. striatum", handle: "geranium-sanguineum-var-striatum", qty: 12 },
      { name: "Digitalis 'Mertonensis'", handle: "digitalis-mertonensis", qty: 7 },
      { name: "Agastache foeniculum 'Black Adder'", handle: "agastache-foeniculum-black-adder", qty: 9 },
      { name: "Sanguisorba officinalis 'Tanna'", handle: "sanguisorba-officinalis-tanna", qty: 7 },
      { name: "Briza media", handle: "briza-media", qty: 9 },
      { name: "Erigeron karvinskianus", handle: "erigeron-karvinskianus-1", qty: 7 },
      { name: "Aster ericoides", handle: "aster-ericoides", qty: 7 },
      { name: "Achillea millefolium 'Walter Funcke'", handle: "achillea-millefolium-walter-funcke", qty: 12 },
      { name: "Astrantia major 'Roma'", handle: "astrantia-major-roma", qty: 9 },
      { name: "Echinacea pallida", handle: "echinacea-pallida-1", qty: 12 },
    ],
  },
  "sunny-side-up-3m\u00b2": {
    pakket: "Sunny Side Up",
    handle: "sunny-side-up",
    size: "3m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-sunny-side-up-3m.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-sunny-side-up-3m.pdf",
    plants: [
      { name: "Alchemilla mollis", handle: "acanthus-mollis-kopie", qty: 3 },
      { name: "Salvia nemorosa 'Blauh\u00fcgel'", handle: "salvia-nemorosa-blauhugel", qty: 3 },
      { name: "Phlomis russeliana", handle: "phlomis-russeliana", qty: 5 },
      { name: "Camassia leichtlinii 'Caerulea'", handle: "camassia-leichtlinii-caerulea", qty: 3 },
      { name: "Achillea millefolium 'Terracotta'", handle: "achillea-terracotta", qty: 3 },
      { name: "Geum 'Banana Daiquiri'", handle: "geum-banana-daiquiri", qty: 3 },
      { name: "Melica ciliata", handle: "melica-ciliata", qty: 2 },
      { name: "Pennisetum orientale 'Fairy Tales'", handle: "pennisetum-orientale-fairy-tales", qty: 1 },
      { name: "Geranium 'Philippe Vapelle'", handle: "geranium-philippe-vapelle", qty: 3 },
      { name: "Echinacea purpurea 'Sunrise'", handle: "echinacea-purpurea-sunrise", qty: 3 },
    ],
  },
  "sunny-side-up-6m\u00b2": {
    pakket: "Sunny Side Up",
    handle: "sunny-side-up",
    size: "6m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-sunny-side-up-6m.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-sunny-side-up-6m.pdf",
    plants: [
      { name: "Alchemilla mollis", handle: "acanthus-mollis-kopie", qty: 6 },
      { name: "Salvia nemorosa 'Blauh\u00fcgel'", handle: "salvia-nemorosa-blauhugel", qty: 6 },
      { name: "Phlomis russeliana", handle: "phlomis-russeliana", qty: 6 },
      { name: "Camassia leichtlinii 'Caerulea'", handle: "camassia-leichtlinii-caerulea", qty: 6 },
      { name: "Achillea millefolium 'Terracotta'", handle: "achillea-terracotta", qty: 6 },
      { name: "Geum 'Banana Daiquiri'", handle: "geum-banana-daiquiri", qty: 6 },
      { name: "Melica ciliata", handle: "melica-ciliata", qty: 5 },
      { name: "Pennisetum orientale 'Fairy Tales'", handle: "pennisetum-orientale-fairy-tales", qty: 3 },
      { name: "Geranium 'Philippe Vapelle'", handle: "geranium-philippe-vapelle", qty: 9 },
      { name: "Echinacea purpurea 'Sunrise'", handle: "echinacea-purpurea-sunrise", qty: 6 },
    ],
  },
  "sunny-side-up-9m\u00b2": {
    pakket: "Sunny Side Up",
    handle: "sunny-side-up",
    size: "9m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-sunny-side-up-9m.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-sunny-side-up-9m.pdf",
    plants: [
      { name: "Alchemilla mollis", handle: "acanthus-mollis-kopie", qty: 10 },
      { name: "Salvia nemorosa 'Blauh\u00fcgel'", handle: "salvia-nemorosa-blauhugel", qty: 9 },
      { name: "Phlomis russeliana", handle: "phlomis-russeliana", qty: 12 },
      { name: "Camassia leichtlinii 'Caerulea'", handle: "camassia-leichtlinii-caerulea", qty: 9 },
      { name: "Achillea millefolium 'Terracotta'", handle: "achillea-terracotta", qty: 10 },
      { name: "Geum 'Banana Daiquiri'", handle: "geum-banana-daiquiri", qty: 12 },
      { name: "Melica ciliata", handle: "melica-ciliata", qty: 9 },
      { name: "Pennisetum orientale 'Fairy Tales'", handle: "pennisetum-orientale-fairy-tales", qty: 7 },
      { name: "Geranium 'Philippe Vapelle'", handle: "geranium-philippe-vapelle", qty: 12 },
      { name: "Echinacea purpurea 'Sunrise'", handle: "echinacea-purpurea-sunrise", qty: 9 },
    ],
  },
  "borderpakket-bees-choice-3m\u00b2": {
    pakket: "Bee's Choice",
    handle: "borderpakket-bees-choice",
    size: "3m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-bees-choice-3m.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-bees-choice-3m.pdf",
    plants: [
      { name: "Gaura lindheimeri 'Whirling Butterflies'", handle: "gaura-lindheimeri-whirling-butterflies", qty: 3 },
      { name: "Nepeta faassenii 'Junior Walker'", handle: "nepeta-faassenii-x-junior-walker-r", qty: 3 },
      { name: "Verbena bonariensis", handle: "verbena-bonariensis", qty: 3 },
      { name: "Acanthus mollis", handle: "acanthus-mollis", qty: 3 },
      { name: "Achillea millefolium 'Walter Funcke'", handle: "achillea-millefolium-walter-funcke", qty: 3 },
      { name: "Salvia microphylla 'Hot Lips'", handle: "salvia-microphylla-hot-lips", qty: 3 },
      { name: "Molinia caerulea 'Heidebraut'", handle: "molinia-caerulea-heidebraut", qty: 2 },
      { name: "Verbascum chaixii 'Album'", handle: "verbascum-chaixii-album", qty: 3 },
      { name: "Sesleria nitida", handle: "sesleria-nitida-1", qty: 3 },
      { name: "Geranium 'Brookside'", handle: "geranium-brookside", qty: 3 },
    ],
  },
  "borderpakket-bees-choice-6m\u00b2": {
    pakket: "Bee's Choice",
    handle: "borderpakket-bees-choice",
    size: "6m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-bees-choice-6m.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-bees-choice-6m.pdf",
    plants: [
      { name: "Gaura lindheimeri 'Whirling Butterflies'", handle: "gaura-lindheimeri-whirling-butterflies", qty: 6 },
      { name: "Nepeta faassenii 'Junior Walker'", handle: "nepeta-faassenii-x-junior-walker-r", qty: 5 },
      { name: "Verbascum chaixii 'Album'", handle: "verbascum-chaixii-album", qty: 6 },
      { name: "Verbena bonariensis", handle: "verbena-bonariensis", qty: 5 },
      { name: "Acanthus mollis", handle: "acanthus-mollis", qty: 5 },
      { name: "Achillea millefolium 'Walter Funcke'", handle: "achillea-millefolium-walter-funcke", qty: 6 },
      { name: "Molinia caerulea 'Heidebraut'", handle: "molinia-caerulea-heidebraut", qty: 5 },
      { name: "Salvia microphylla 'Hot Lips'", handle: "salvia-microphylla-hot-lips", qty: 6 },
      { name: "Sesleria nitida", handle: "sesleria-nitida-1", qty: 6 },
      { name: "Geranium 'Brookside'", handle: "geranium-brookside", qty: 9 },
    ],
  },
  "borderpakket-bees-choice-9m\u00b2": {
    pakket: "Bee's Choice",
    handle: "borderpakket-bees-choice",
    size: "9m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-bees-choice-9m.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-bees-choice-9m.pdf",
    plants: [
      { name: "Gaura lindheimeri 'Whirling Butterflies'", handle: "gaura-lindheimeri-whirling-butterflies", qty: 9 },
      { name: "Nepeta faassenii 'Junior Walker'", handle: "nepeta-faassenii-x-junior-walker-r", qty: 7 },
      { name: "Verbascum chaixii 'Album'", handle: "verbascum-chaixii-album", qty: 12 },
      { name: "Verbena bonariensis", handle: "verbena-bonariensis", qty: 9 },
      { name: "Acanthus mollis", handle: "acanthus-mollis", qty: 7 },
      { name: "Achillea millefolium 'Walter Funcke'", handle: "achillea-millefolium-walter-funcke", qty: 12 },
      { name: "Molinia caerulea 'Heidebraut'", handle: "molinia-caerulea-heidebraut", qty: 7 },
      { name: "Salvia microphylla 'Hot Lips'", handle: "salvia-microphylla-hot-lips", qty: 9 },
      { name: "Sesleria nitida", handle: "sesleria-nitida-1", qty: 12 },
      { name: "Geranium 'Brookside'", handle: "geranium-brookside", qty: 15 },
    ],
  },
  "borderpakket-prairietuin-3m\u00b2": {
    pakket: "Prairietuin",
    handle: "borderpakket-prairietuin",
    size: "3m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-prairietuin-3m.jpg",
    image_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-prairietuin-3m-organisch.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-prairietuin-3m.pdf",
    pdf_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-prairietuin-3m-organisch.pdf",
    plants: [
      { name: "Liatris spicata", handle: "liatris-spicata", qty: 3 },
      { name: "Panicum virgatum 'Heiliger Hain'", handle: "panicum-virgatum-heiliger-hain", qty: 2 },
      { name: "Molinia caerulea 'Heidebraut'", handle: "molinia-caerulea-heidebraut", qty: 1 },
      { name: "Scabiosa caucasica 'Perfecta'", handle: "scabiosa-caucasica-perfecta", qty: 3 },
      { name: "Verbena bonariensis", handle: "verbena-bonariensis", qty: 3 },
      { name: "Echinacea purpurea 'Alba'", handle: "echinacea-purpurea-alba", qty: 3 },
      { name: "Agastache 'Blue Fortune'", handle: "agastache-blue-fortune", qty: 3 },
      { name: "Aster ericoides", handle: "aster-ericoides", qty: 3 },
      { name: "Salvia nemorosa", handle: "salvia-nemorosa", qty: 3 },
      { name: "Echinacea purpurea", handle: "echinacea-purpurea", qty: 3 },
      { name: "Achillea millefolium 'Paprika'", handle: "achillea-millefolium-paprika", qty: 3 },
    ],
  },
  "borderpakket-prairietuin-6m\u00b2": {
    pakket: "Prairietuin",
    handle: "borderpakket-prairietuin",
    size: "6m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-prairietuin-6m.jpg",
    image_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-prairietuin-6m-organisch.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-prairietuin-6m.pdf",
    pdf_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-prairietuin-6m-organisch.pdf",
    plants: [
      { name: "Liatris spicata", handle: "liatris-spicata", qty: 6 },
      { name: "Panicum virgatum 'Heiliger Hain'", handle: "panicum-virgatum-heiliger-hain", qty: 5 },
      { name: "Molinia caerulea 'Heidebraut'", handle: "molinia-caerulea-heidebraut", qty: 3 },
      { name: "Scabiosa caucasica 'Perfecta'", handle: "scabiosa-caucasica-perfecta", qty: 6 },
      { name: "Verbena bonariensis", handle: "verbena-bonariensis", qty: 5 },
      { name: "Echinacea purpurea", handle: "echinacea-purpurea", qty: 6 },
      { name: "Agastache 'Blue Fortune'", handle: "agastache-blue-fortune", qty: 6 },
      { name: "Aster ericoides", handle: "aster-ericoides", qty: 6 },
      { name: "Salvia nemorosa", handle: "salvia-nemorosa", qty: 6 },
      { name: "Achillea millefolium 'Paprika'", handle: "achillea-millefolium-paprika", qty: 6 },
      { name: "Echinacea purpurea 'Alba'", handle: "echinacea-purpurea-alba", qty: 6 },
    ],
  },
  "borderpakket-prairietuin-9m\u00b2": {
    pakket: "Prairietuin",
    handle: "borderpakket-prairietuin",
    size: "9m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-prairietuin-9m.jpg",
    image_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-prairietuin-9m-organisch.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-prairietuin-9m.pdf",
    pdf_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-prairietuin-9m-organisch.pdf",
    plants: [
      { name: "Liatris spicata", handle: "liatris-spicata", qty: 9 },
      { name: "Panicum virgatum 'Heiliger Hain'", handle: "panicum-virgatum-heiliger-hain", qty: 7 },
      { name: "Molinia caerulea 'Heidebraut'", handle: "molinia-caerulea-heidebraut", qty: 5 },
      { name: "Scabiosa caucasica 'Perfecta'", handle: "scabiosa-caucasica-perfecta", qty: 15 },
      { name: "Verbena bonariensis", handle: "verbena-bonariensis", qty: 9 },
      { name: "Echinacea purpurea 'Alba'", handle: "echinacea-purpurea-alba", qty: 9 },
      { name: "Echinacea purpurea", handle: "echinacea-purpurea", qty: 12 },
      { name: "Salvia nemorosa", handle: "salvia-nemorosa", qty: 9 },
      { name: "Aster ericoides", handle: "aster-ericoides", qty: 9 },
      { name: "Agastache 'Blue Fortune'", handle: "agastache-blue-fortune", qty: 9 },
      { name: "Achillea millefolium 'Paprika'", handle: "achillea-millefolium-paprika", qty: 12 },
    ],
  },
  "borderpakket-lush-lovely-3m\u00b2": {
    pakket: "Lush & Lovely",
    handle: "borderpakket-lush-lovely",
    size: "3m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-lush-lovely-3m.jpg",
    image_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-lush-lovely-3m-organisch.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-lush-lovely-3m.pdf",
    pdf_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-lush-lovely-3m-organisch.pdf",
    plants: [
      { name: "Calamagrostis acutiflora 'Karl Foerster'", handle: "calamagrostis-acutiflora-karl-foerster", qty: 2 },
      { name: "Veronica longifolia 'Blauriesin'", handle: "veronica-longifolia-blauriesin", qty: 3 },
      { name: "Phlomis tuberosa 'Amazone'", handle: "phlomis-tuberosa-amazone", qty: 3 },
      { name: "Pulmonaria officinalis", handle: "pulmonaria-officinalis", qty: 3 },
      { name: "Persicaria bistorta 'Superba'", handle: "persicaria-bistorta-superba", qty: 3 },
      { name: "Scabiosa columbaria 'Pink Mist'", handle: "scabiosa-columbaria-pink-mist", qty: 3 },
      { name: "Papaver orientale 'Patty's Plum'", handle: "papaver-orientale-pattys-plum", qty: 3 },
      { name: "Campanula lactiflora 'Loddon Anna'", handle: "campanula-lactiflora-loddon-anna", qty: 3 },
      { name: "Geranium cantabrigiense 'Biokovo'", handle: "geranium-cantabrigiense-biokovo", qty: 3 },
      { name: "Pennisetum alopecuroides 'Goldstrich'", handle: "pennisetum-alopecuroides-goldstrich", qty: 2 },
    ],
  },
  "borderpakket-lush-lovely-6m\u00b2": {
    pakket: "Lush & Lovely",
    handle: "borderpakket-lush-lovely",
    size: "6m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-lush-lovely-6m.jpg",
    image_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-lush-lovely-6m-organisch.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-lush-lovely-6m.pdf",
    pdf_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-lush-lovely-6m-organisch.pdf",
    plants: [
      { name: "Geranium cantabrigiense 'Biokovo'", handle: "geranium-cantabrigiense-biokovo", qty: 6 },
      { name: "Calamagrostis acutiflora 'Karl Foerster'", handle: "calamagrostis-acutiflora-karl-foerster", qty: 5 },
      { name: "Veronica longifolia 'Blauriesin'", handle: "veronica-longifolia-blauriesin", qty: 6 },
      { name: "Pulmonaria officinalis", handle: "pulmonaria-officinalis", qty: 6 },
      { name: "Phlomis tuberosa 'Amazone'", handle: "phlomis-tuberosa-amazone", qty: 6 },
      { name: "Persicaria bistorta 'Superba'", handle: "persicaria-bistorta-superba", qty: 6 },
      { name: "Scabiosa columbaria 'Pink Mist'", handle: "scabiosa-columbaria-pink-mist", qty: 6 },
      { name: "Papaver orientale 'Patty's Plum'", handle: "papaver-orientale-pattys-plum", qty: 5 },
      { name: "Campanula lactiflora 'Loddon Anna'", handle: "campanula-lactiflora-loddon-anna", qty: 6 },
      { name: "Pennisetum alopecuroides 'Goldstrich'", handle: "pennisetum-alopecuroides-goldstrich", qty: 5 },
    ],
  },
  "borderpakket-lush-lovely-9m\u00b2": {
    pakket: "Lush & Lovely",
    handle: "borderpakket-lush-lovely",
    size: "9m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-lush-lovely-9m.jpg",
    image_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-lush-lovely-9m-organisch.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-lush-lovely-9m.pdf",
    pdf_url_organisch: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-lush-lovely-9m-organisch.pdf",
    plants: [
      { name: "Geranium cantabrigiense 'Biokovo'", handle: "geranium-cantabrigiense-biokovo", qty: 9 },
      { name: "Calamagrostis acutiflora 'Karl Foerster'", handle: "calamagrostis-acutiflora-karl-foerster", qty: 7 },
      { name: "Veronica longifolia 'Blauriesin'", handle: "veronica-longifolia-blauriesin", qty: 9 },
      { name: "Pulmonaria officinalis", handle: "pulmonaria-officinalis", qty: 12 },
      { name: "Phlomis tuberosa 'Amazone'", handle: "phlomis-tuberosa-amazone", qty: 9 },
      { name: "Persicaria bistorta 'Superba'", handle: "persicaria-bistorta-superba", qty: 9 },
      { name: "Scabiosa columbaria 'Pink Mist'", handle: "scabiosa-columbaria-pink-mist", qty: 9 },
      { name: "Campanula lactiflora 'Loddon Anna'", handle: "campanula-lactiflora-loddon-anna", qty: 12 },
      { name: "Pennisetum alopecuroides 'Goldstrich'", handle: "pennisetum-alopecuroides-goldstrich", qty: 7 },
      { name: "Papaver orientale 'Patty's Plum'", handle: "papaver-orientale-pattys-plum", qty: 7 },
    ],
  },
  "stoeptuin-english-cottage-1 meter": {
    pakket: "English Cottage",
    handle: "stoeptuin-english-cottage",
    size: "1 meter",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-english-cottage-3m.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-english-cottage-3m.pdf",
    plants: [
      { name: "Verbena bonariensis 'Lollipop'", handle: "verbena-bonariensis-lollipop", qty: 1 },
      { name: "Luzula nivea", handle: "luzula-nivea", qty: 1 },
      { name: "Ajuga reptans 'Rosea'", handle: "ajuga-reptans-rosea", qty: 1 },
      { name: "Calamintha nepeta 'Blue Cloud'", handle: "calamintha-nepeta-blue-cloud", qty: 1 },
      { name: "Lythrum salicaria 'Robert'", handle: "lythrum-salicaria-robert", qty: 1 },
      { name: "Astrantia major 'Florence'", handle: "astrantia-major-florence", qty: 1 },
      { name: "Echinacea purpurea 'Leuchtstern'", handle: "echinacea-purpurea-leuchtstern", qty: 1 },
    ],
  },
  "stoeptuin-english-cottage-3 meter": {
    pakket: "English Cottage",
    handle: "stoeptuin-english-cottage",
    size: "3 meter",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-english-cottage-6m.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-english-cottage-6m.pdf",
    plants: [
      { name: "Verbena bonariensis 'Lollipop'", handle: "verbena-bonariensis-lollipop", qty: 2 },
      { name: "Luzula nivea", handle: "luzula-nivea", qty: 2 },
      { name: "Ajuga reptans 'Rosea'", handle: "ajuga-reptans-rosea", qty: 2 },
      { name: "Calamintha nepeta 'Blue Cloud'", handle: "calamintha-nepeta-blue-cloud", qty: 2 },
      { name: "Lythrum salicaria 'Robert'", handle: "lythrum-salicaria-robert", qty: 2 },
      { name: "Echinacea purpurea 'Leuchtstern'", handle: "echinacea-purpurea-leuchtstern", qty: 2 },
      { name: "Astrantia major 'Florence'", handle: "astrantia-major-florence", qty: 1 },
    ],
  },
  "stoeptuin-english-cottage-5 meter": {
    pakket: "English Cottage",
    handle: "stoeptuin-english-cottage",
    size: "5 meter",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-english-cottage-9m.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-english-cottage-9m.pdf",
    plants: [
      { name: "Luzula nivea", handle: "luzula-nivea", qty: 2 },
      { name: "Ajuga reptans 'Rosea'", handle: "ajuga-reptans-rosea", qty: 6 },
      { name: "Calamintha nepeta 'Blue Cloud'", handle: "calamintha-nepeta-blue-cloud", qty: 2 },
      { name: "Lythrum salicaria 'Robert'", handle: "lythrum-salicaria-robert", qty: 3 },
      { name: "Echinacea purpurea 'Leuchtstern'", handle: "echinacea-purpurea-leuchtstern", qty: 3 },
      { name: "Astrantia major 'Florence'", handle: "astrantia-major-florence", qty: 2 },
      { name: "Verbena bonariensis 'Lollipop'", handle: "verbena-bonariensis-lollipop", qty: 3 },
    ],
  },
  "stoeptuin-crimson-meadow-1 meter": {
    pakket: "Crimson Meadow",
    handle: "stoeptuin-crimson-meadow",
    size: "1 meter",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-crimson-meadow-3m.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-crimson-meadow-3m.pdf",
    plants: [
      { name: "Geranium 'Philippe Vapelle'", handle: "geranium-philippe-vapelle", qty: 2 },
      { name: "Penstemon hybride 'White Bedder'", handle: "penstemon-hybride-white-bedder", qty: 1 },
      { name: "Primula bulleesiana", handle: "primula-bulleesiana", qty: 4 },
      { name: "Agastache 'Blue Fortune'", handle: "agastache-blue-fortune", qty: 1 },
      { name: "Briza media", handle: "briza-media", qty: 2 },
    ],
  },
  "stoeptuin-crimson-meadow-3 meter": {
    pakket: "Crimson Meadow",
    handle: "stoeptuin-crimson-meadow",
    size: "3 meter",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-crimson-meadow-6m.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-crimson-meadow-6m.pdf",
    plants: [
      { name: "Geranium 'Philippe Vapelle'", handle: "geranium-philippe-vapelle", qty: 3 },
      { name: "Penstemon hybride 'White Bedder'", handle: "penstemon-hybride-white-bedder", qty: 3 },
      { name: "Primula bulleesiana", handle: "primula-bulleesiana", qty: 6 },
      { name: "Agastache 'Blue Fortune'", handle: "agastache-blue-fortune", qty: 2 },
      { name: "Briza media", handle: "briza-media", qty: 3 },
    ],
  },
  "stoeptuin-crimson-meadow-5 meter": {
    pakket: "Crimson Meadow",
    handle: "stoeptuin-crimson-meadow",
    size: "5 meter",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-crimson-meadow-9m.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-crimson-meadow-9m.pdf",
    plants: [
      { name: "Geranium 'Philippe Vapelle'", handle: "geranium-philippe-vapelle", qty: 5 },
      { name: "Penstemon hybride 'White Bedder'", handle: "penstemon-hybride-white-bedder", qty: 5 },
      { name: "Primula bulleesiana", handle: "primula-bulleesiana", qty: 9 },
      { name: "Agastache 'Blue Fortune'", handle: "agastache-blue-fortune", qty: 3 },
      { name: "Briza media", handle: "briza-media", qty: 3 },
    ],
  },
  "borderpakket-wadi-3m\u00b2": {
    pakket: "Wadi",
    handle: "borderpakket-wadi",
    size: "3m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-wadi-3m.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-wadi-3m.pdf",
    plants: [
      { name: "Filipendula ulmaria", handle: "filipendula-ulmaria", qty: 1 },
      { name: "Ajuga reptans", handle: "ajuga-reptans", qty: 3 },
      { name: "Molinia caerulea 'Moorhexe'", handle: "molinia-caerulea-moorhexe", qty: 1 },
      { name: "Verbena bonariensis", handle: "verbena-bonariensis", qty: 3 },
      { name: "Persicaria affinis 'Donald Lowndes'", handle: "persicaria-affinis-donald-lowndes", qty: 3 },
      { name: "Iris pseudacorus", handle: "iris-pseudacorus", qty: 3 },
      { name: "Sanguisorba officinalis", handle: "sanguisorba-officinalis", qty: 3 },
    ],
  },
  "borderpakket-wadi-6m\u00b2": {
    pakket: "Wadi",
    handle: "borderpakket-wadi",
    size: "6m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-wadi-6m.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-wadi-6m.pdf",
    plants: [
      { name: "Filipendula ulmaria", handle: "filipendula-ulmaria", qty: 3 },
      { name: "Ajuga reptans", handle: "ajuga-reptans", qty: 6 },
      { name: "Molinia caerulea 'Moorhexe'", handle: "molinia-caerulea-moorhexe", qty: 3 },
      { name: "Verbena bonariensis", handle: "verbena-bonariensis", qty: 5 },
      { name: "Persicaria affinis 'Donald Lowndes'", handle: "persicaria-affinis-donald-lowndes", qty: 6 },
      { name: "Iris pseudacorus", handle: "iris-pseudacorus", qty: 6 },
      { name: "Sanguisorba officinalis", handle: "sanguisorba-officinalis", qty: 6 },
    ],
  },
  "borderpakket-wadi-9m\u00b2": {
    pakket: "Wadi",
    handle: "borderpakket-wadi",
    size: "9m\u00b2",
    video: "",           // TODO: YouTube/Vimeo URL
    image_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-wadi-9m.jpg",
    pdf_url: "https://hhosliyehiznannuqbps.supabase.co/storage/v1/object/public/borderpakket-plans/borderplans/borderplan-wadi-9m.pdf",
    plants: [
      { name: "Filipendula ulmaria", handle: "filipendula-ulmaria", qty: 6 },
      { name: "Ajuga reptans", handle: "ajuga-reptans", qty: 9 },
      { name: "Molinia caerulea 'Moorhexe'", handle: "molinia-caerulea-moorhexe", qty: 6 },
      { name: "Verbena bonariensis", handle: "verbena-bonariensis", qty: 7 },
      { name: "Persicaria affinis 'Donald Lowndes'", handle: "persicaria-affinis-donald-lowndes", qty: 9 },
      { name: "Iris pseudacorus", handle: "iris-pseudacorus", qty: 9 },
      { name: "Sanguisorba officinalis", handle: "sanguisorba-officinalis", qty: 9 },
    ],
  },

  "PAK-BOR-GARD-3M": {
    pakket: "garden party",
    handle: "borderpakket-garden-party",
    size: "3m²",
    video: "",
    image_url: "",
    image_url_organisch: "",
    pdf_url: "",
    pdf_url_organisch: "",
    plants: [
      { name: "Primula vialii", handle: "primula-vialii", qty: 3 },
      { name: "Nepeta faassenii 'Junior Walker'", handle: "nepeta-faassenii-x-junior-walker-r", qty: 3 },
      { name: "Veronica 'First Love'", handle: "veronica-first-love", qty: 3 },
      { name: "Digitalis purpurea 'Excelsior Hybrids'", handle: "digitalis-purpurea-excelsior-hybrids", qty: 3 },
      { name: "Thalictrum 'Black Stockings'", handle: "thalictrum-black-stockings", qty: 3 },
      { name: "Scabiosa Columbaria", handle: "scabiosa-columbaria", qty: 3 },
      { name: "Luzula nivea", handle: "luzula-nivea", qty: 3 },
      { name: "Cirsium rivulare 'Atropurpureum'", handle: "cirsium-rivulare-atropurpureum", qty: 3 },
      { name: "Geranium cantabrigiense 'Biokovo'", handle: "geranium-cantabrigiense-biokovo", qty: 3 },
      { name: "Dianthus carthusianorum", handle: "dianthus-carthusianorum", qty: 3 },
      { name: "Salvia nemorosa 'Rose Queen'", handle: "salvia-nemorosa-rose-queen", qty: 3 },
    ],
  },
  "PAK-BOR-GARD-6M": {
    pakket: "garden party",
    handle: "borderpakket-garden-party",
    size: "6m²",
    video: "",
    image_url: "",
    image_url_organisch: "",
    pdf_url: "",
    pdf_url_organisch: "",
    plants: [
      { name: "Primula vialii", handle: "primula-vialii", qty: 6 },
      { name: "Nepeta faassenii 'Junior Walker'", handle: "nepeta-faassenii-x-junior-walker-r", qty: 6 },
      { name: "Veronica 'First Love'", handle: "veronica-first-love", qty: 6 },
      { name: "Digitalis purpurea 'Excelsior Hybrids'", handle: "digitalis-purpurea-excelsior-hybrids", qty: 6 },
      { name: "Thalictrum 'Black Stockings'", handle: "thalictrum-black-stockings", qty: 6 },
      { name: "Scabiosa Columbaria", handle: "scabiosa-columbaria", qty: 6 },
      { name: "Luzula nivea", handle: "luzula-nivea", qty: 6 },
      { name: "Cirsium rivulare 'Atropurpureum'", handle: "cirsium-rivulare-atropurpureum", qty: 6 },
      { name: "Geranium cantabrigiense 'Biokovo'", handle: "geranium-cantabrigiense-biokovo", qty: 6 },
      { name: "Dianthus carthusianorum", handle: "dianthus-carthusianorum", qty: 6 },
      { name: "Salvia nemorosa 'Rose Queen'", handle: "salvia-nemorosa-rose-queen", qty: 6 },
    ],
  },
  "PAK-BOR-GARD-9M": {
    pakket: "garden party",
    handle: "borderpakket-garden-party",
    size: "9m²",
    video: "",
    image_url: "",
    image_url_organisch: "",
    pdf_url: "",
    pdf_url_organisch: "",
    plants: [
      { name: "Primula vialii", handle: "primula-vialii", qty: 9 },
      { name: "Nepeta faassenii 'Junior Walker'", handle: "nepeta-faassenii-x-junior-walker-r", qty: 9 },
      { name: "Veronica 'First Love'", handle: "veronica-first-love", qty: 9 },
      { name: "Digitalis purpurea 'Excelsior Hybrids'", handle: "digitalis-purpurea-excelsior-hybrids", qty: 9 },
      { name: "Thalictrum 'Black Stockings'", handle: "thalictrum-black-stockings", qty: 9 },
      { name: "Scabiosa Columbaria", handle: "scabiosa-columbaria", qty: 9 },
      { name: "Luzula nivea", handle: "luzula-nivea", qty: 9 },
      { name: "Cirsium rivulare 'Atropurpureum'", handle: "cirsium-rivulare-atropurpureum", qty: 9 },
      { name: "Geranium cantabrigiense 'Biokovo'", handle: "geranium-cantabrigiense-biokovo", qty: 9 },
      { name: "Dianthus carthusianorum", handle: "dianthus-carthusianorum", qty: 9 },
      { name: "Salvia nemorosa 'Rose Queen'", handle: "salvia-nemorosa-rose-queen", qty: 9 },
    ],
  },
  "PAK-BOR-WOOD-3M": {
    pakket: "woodland",
    handle: "borderpakket-woodland",
    size: "3m²",
    video: "",
    image_url: "",
    image_url_organisch: "",
    pdf_url: "",
    pdf_url_organisch: "",
    plants: [
      { name: "Liriope muscari 'Lilac Wonder'", handle: "liriope-muscari-lilac-wonder", qty: 3 },
      { name: "Brunnera macrophylla ‘Jack of Diamonds’", handle: "brunnera-macrophylla-jack-of-diamonds", qty: 3 },
      { name: "Dryopteris filix-mas", handle: "dryopteris-filix-mas", qty: 3 },
      { name: "Geranium macrorrhizum 'Spessart'", handle: "geranium-macrorrhizum-spessart", qty: 3 },
      { name: "Helleborus orientalis 'Mixed Colours'", handle: "helleborus-orientalis-mixed-colours", qty: 3 },
      { name: "Astilbe x arendsii 'Amerika'", handle: "astilbe-x-arendsii-amerika", qty: 3 },
      { name: "Carex oshimensis 'Evergreen'", handle: "carex-oshimensis-evergreen", qty: 3 },
      { name: "Aster divaricatus", handle: "aster-divaricatus", qty: 3 },
    ],
  },
  "PAK-BOR-WOOD-6M": {
    pakket: "woodland",
    handle: "borderpakket-woodland",
    size: "6m²",
    video: "",
    image_url: "",
    image_url_organisch: "",
    pdf_url: "",
    pdf_url_organisch: "",
    plants: [
      { name: "Liriope muscari 'Lilac Wonder'", handle: "liriope-muscari-lilac-wonder", qty: 6 },
      { name: "Brunnera macrophylla ‘Jack of Diamonds’", handle: "brunnera-macrophylla-jack-of-diamonds", qty: 6 },
      { name: "Dryopteris filix-mas", handle: "dryopteris-filix-mas", qty: 6 },
      { name: "Geranium macrorrhizum 'Spessart'", handle: "geranium-macrorrhizum-spessart", qty: 6 },
      { name: "Helleborus orientalis 'Mixed Colours'", handle: "helleborus-orientalis-mixed-colours", qty: 6 },
      { name: "Astilbe x arendsii 'Amerika'", handle: "astilbe-x-arendsii-amerika", qty: 6 },
      { name: "Carex oshimensis 'Evergreen'", handle: "carex-oshimensis-evergreen", qty: 6 },
      { name: "Aster divaricatus", handle: "aster-divaricatus", qty: 6 },
    ],
  },
  "PAK-BOR-WOOD-9M": {
    pakket: "woodland",
    handle: "borderpakket-woodland",
    size: "9m²",
    video: "",
    image_url: "",
    image_url_organisch: "",
    pdf_url: "",
    pdf_url_organisch: "",
    plants: [
      { name: "Liriope muscari 'Lilac Wonder'", handle: "liriope-muscari-lilac-wonder", qty: 9 },
      { name: "Brunnera macrophylla ‘Jack of Diamonds’", handle: "brunnera-macrophylla-jack-of-diamonds", qty: 9 },
      { name: "Dryopteris filix-mas", handle: "dryopteris-filix-mas", qty: 9 },
      { name: "Geranium macrorrhizum 'Spessart'", handle: "geranium-macrorrhizum-spessart", qty: 9 },
      { name: "Helleborus orientalis 'Mixed Colours'", handle: "helleborus-orientalis-mixed-colours", qty: 9 },
      { name: "Astilbe x arendsii 'Amerika'", handle: "astilbe-x-arendsii-amerika", qty: 9 },
      { name: "Carex oshimensis 'Evergreen'", handle: "carex-oshimensis-evergreen", qty: 9 },
      { name: "Aster divaricatus", handle: "aster-divaricatus", qty: 9 },
    ],
  },
  "PAK-BOR-INDI-3M": {
    pakket: "indian summer",
    handle: "borderpakket-indian-summer",
    size: "3m²",
    video: "",
    image_url: "",
    image_url_organisch: "",
    pdf_url: "",
    pdf_url_organisch: "",
    plants: [
      { name: "Achillea millefolium 'Walter Funcke'", handle: "achillea-millefolium-walter-funcke", qty: 3 },
      { name: "Aster ericoides 'Herbstmyrte'", handle: "aster-ericoides", qty: 3 },
      { name: "Stipa gigantea", handle: "stipa-gigantea", qty: 3 },
      { name: "Euphorbia amygdaloides 'Purpurea'", handle: "euphorbia-amygdaloides-purpurea", qty: 3 },
      { name: "Rudbeckia triloba 'Prairie Glow'", handle: "rudbeckia-triloba-prairie-glow", qty: 3 },
      { name: "Persicaria amplexicaulis 'Blackfield'", handle: "persicaria-amplexicaulis-blackfield", qty: 3 },
      { name: "Echinacea purpurea 'Supreme Cantaloupe'", handle: "echinacea-purpurea-supreme-cantaloupe", qty: 3 },
      { name: "Trollius 'Alabaster'", handle: "trollius-alabaster", qty: 3 },
      { name: "Scabiosa ochroleuca", handle: "scabiosa-ochroleuca", qty: 3 },
      { name: "Sanguisorba officinalis 'Tanna'", handle: "sanguisorba-officinalis-tanna", qty: 3 },
    ],
  },
  "PAK-BOR-INDI-6M": {
    pakket: "indian summer",
    handle: "borderpakket-indian-summer",
    size: "6m²",
    video: "",
    image_url: "",
    image_url_organisch: "",
    pdf_url: "",
    pdf_url_organisch: "",
    plants: [
      { name: "Achillea millefolium 'Walter Funcke'", handle: "achillea-millefolium-walter-funcke", qty: 6 },
      { name: "Aster ericoides 'Herbstmyrte'", handle: "aster-ericoides", qty: 6 },
      { name: "Stipa gigantea", handle: "stipa-gigantea", qty: 6 },
      { name: "Euphorbia amygdaloides 'Purpurea'", handle: "euphorbia-amygdaloides-purpurea", qty: 6 },
      { name: "Rudbeckia triloba 'Prairie Glow'", handle: "rudbeckia-triloba-prairie-glow", qty: 6 },
      { name: "Persicaria amplexicaulis 'Blackfield'", handle: "persicaria-amplexicaulis-blackfield", qty: 6 },
      { name: "Echinacea purpurea 'Supreme Cantaloupe'", handle: "echinacea-purpurea-supreme-cantaloupe", qty: 6 },
      { name: "Trollius 'Alabaster'", handle: "trollius-alabaster", qty: 6 },
      { name: "Scabiosa ochroleuca", handle: "scabiosa-ochroleuca", qty: 6 },
      { name: "Sanguisorba officinalis 'Tanna'", handle: "sanguisorba-officinalis-tanna", qty: 6 },
    ],
  },
  "PAK-BOR-INDI-9M": {
    pakket: "indian summer",
    handle: "borderpakket-indian-summer",
    size: "9m²",
    video: "",
    image_url: "",
    image_url_organisch: "",
    pdf_url: "",
    pdf_url_organisch: "",
    plants: [
      { name: "Achillea millefolium 'Walter Funcke'", handle: "achillea-millefolium-walter-funcke", qty: 9 },
      { name: "Aster ericoides 'Herbstmyrte'", handle: "aster-ericoides", qty: 9 },
      { name: "Stipa gigantea", handle: "stipa-gigantea", qty: 9 },
      { name: "Euphorbia amygdaloides 'Purpurea'", handle: "euphorbia-amygdaloides-purpurea", qty: 9 },
      { name: "Rudbeckia triloba 'Prairie Glow'", handle: "rudbeckia-triloba-prairie-glow", qty: 9 },
      { name: "Persicaria amplexicaulis 'Blackfield'", handle: "persicaria-amplexicaulis-blackfield", qty: 9 },
      { name: "Echinacea purpurea 'Supreme Cantaloupe'", handle: "echinacea-purpurea-supreme-cantaloupe", qty: 9 },
      { name: "Trollius 'Alabaster'", handle: "trollius-alabaster", qty: 9 },
      { name: "Scabiosa ochroleuca", handle: "scabiosa-ochroleuca", qty: 9 },
      { name: "Sanguisorba officinalis 'Tanna'", handle: "sanguisorba-officinalis-tanna", qty: 9 },
    ],
  }
};
